<nav class="navbar navbar-expand-lg navbar-dark bg-primarys desktop fixed-top">
  <div
    class="custom-container d-flex justify-content-between align-items-center w-100"
    *ngIf="this.useremail; else notlogin">
    <a class="navbar-brand align-items-center setbutton" href="/">
      <img src="assets/images/Group 38.png" alt="Logo">
      <!-- src\assets\images\Group 36 (1).png -->
    </a>
    <!-- src\assets\images\Group 32.png -->
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <span class="nav-link text-white">
            <div class="city-selector-wrapper"
              (mouseenter)="isHovering = true; showCitySuggestions = true"
              (mouseleave)="isHovering = false; maybeHideSuggestions()">
              <div class="city-selector">
                <input type="text"
                  class="search-city-input"
                  [(ngModel)]="searchCityQuery"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                  (click)="onCityInputClick()"
                  [placeholder]="selectedCityName ? selectedCityName : 'Mumbai'"
                  readonly />

                <span class="dropdown-icon">
                  <i class="fas"
                    [ngClass]="showCitySuggestions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>

                <div class="city-suggestions-box"
                  *ngIf="showCitySuggestions">
                  <div class="section">
                    <h6>Popular Cities</h6>
                    <div class="city-grid">
                      <span *ngFor="let city of popularCities"
                        (click)="selectCity(city)">
                        {{ city.name }}
                      </span>
                    </div>
                  </div>

                  <div class="section">
                    <h6>Other Cities</h6>
                    <div class="city-grid">
                      <span *ngFor="let city of otherCities"
                        (click)="selectCity(city)">
                        {{ city.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </li>

        <li class="nav-item">
          <span class="nav-link text-white setbutton"
            style="cursor: pointer; margin-top: 7px;"
            (click)="rentAgreementNavigate()"> Rent Agreement</span>

        </li>
        <!-- <li class="nav-item">
          <span class="nav-link text-white">Rent Calculator</span>
        </li> -->
      </ul>
    </div>

    <div class="d-flex align-items-center endside">
      <span class="btn  btn-lights setbutton" (click)="propertynavigate()">
        <i class="fa fa-files-o"></i>&nbsp;&nbsp;&nbsp; List Property
        <span class="badge btn-warning text-dark badge-custom">Free</span>
      </span>
      <div class="d-flex align-items-center user-profile-section">
        <span class="username me-2">{{ userfullname }}</span>

        <ng-container *ngIf="adminlogo; else noImage">
          <div
            class="dropdown-wrapper"
            [matMenuTriggerFor]="menu"
            (menuOpened)="onMenuOpened()"
            (menuClosed)="onMenuClosed()">
            <img [src]="adminlogo" class="admin-profile-img" alt="Profile" />
            <mat-icon class="dropdown-do">
              {{ menuOpen ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>
        </ng-container>

        <ng-template #noImage>
          <button mat-icon-button [matMenuTriggerFor]="menu"
            class="user-icon setbutton">
            <i class="fa fa-user-circle fa-lg"></i>
          </button>
        </ng-template>
      </div>
      <mat-menu #menu="matMenu">
        <button mat-menu-item
          routerLink="/update/profile/username/userid/activetab">
          <i class="fas fa-user" style="color: #004aad; font-size: 16px;"></i>
          <span>&nbsp; Manage Profile</span>
        </button>
        <button mat-menu-item (click)="navigateToUserProprty()">
          <i class="fa fa-building"
            style="color: #004aad; font-size: 16px;"></i>
          &nbsp; My Listings
        </button>
        <button mat-menu-item (click)="chnagepassword()">
          <i class="fa fa-key" style="color: #004aad; font-size: 16px;"></i>
          &nbsp; Change Password
        </button>

        <button mat-menu-item (click)="navigateToUserProjects()"
          *ngIf="builder">
          <i class="fa fa-home" style="color: #004aad; font-size: 16px;"></i>
          &nbsp; My Projects
        </button>
        <button mat-menu-item (click)="userLogout()">
          <i class="fas fa-sign-out-alt"
            style="color: #004aad; font-size: 16px;"></i>
          &nbsp; Logout
        </button>
      </mat-menu>

      <!-- <span class="btn btn-lights me-2" (click)="projectnavigate()">
        <i class="fa fa-building"></i>&nbsp;&nbsp;&nbsp; Real Estate Projects
        <span class="badge bg-dark text-white badge-custom">Free</span>
      </span> -->

    </div>
  </div>

  <ng-template #notlogin>
    <div
      class="custom-container d-flex justify-content-between align-items-center w-100">
      <a class="navbar-brand d-flex align-items-center setbutton" href="#">
        <img src="assets/images/Group 38.png" alt="Logo">
      </a>

      <div class="collapse navbar-collapse">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <span class="nav-link text-white">

              <div class="city-selector-wrapper"
                (mouseenter)="isHovering = true; showCitySuggestions = true"
                (mouseleave)="isHovering = false; maybeHideSuggestions()">
                <div class="city-selector">
                  <input type="text"
                    class="search-city-input"
                    [(ngModel)]="searchCityQuery"
                    (focus)="onInputFocus()"
                    (blur)="onInputBlur()"
                    (click)="onCityInputClick()"
                    [placeholder]="selectedCityName ? selectedCityName : 'Mumbai'"
                    readonly />

                  <span class="dropdown-icon">
                    <i class="fas"
                      [ngClass]="showCitySuggestions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </span>

                  <div class="city-suggestions-box"
                    *ngIf="showCitySuggestions">
                    <div class="section">
                      <h6>Popular Cities</h6>
                      <div class="city-grid">
                        <span *ngFor="let city of popularCities"
                          (click)="selectCity(city)">
                          {{ city.name }}
                        </span>
                      </div>
                    </div>

                    <div class="section">
                      <h6>Other Cities</h6>
                      <div class="city-grid">
                        <span *ngFor="let city of otherCities"
                          (click)="selectCity(city)">
                          {{ city.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="city-selector"
                (mouseleave)="isHovering = false; maybeHideSuggestions()"
                (mouseenter)="onMouseEnter()">

                <input type="text"
                  class="search-city-input"
                  [(ngModel)]="searchCityQuery"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                  (click)="onCityInputClick()"
                  [placeholder]="selectedCityName ? selectedCityName : 'Mumbai'"
                  readonly />

                <span class="dropdown-icon">
                  <i class="fas"
                    [ngClass]="showCitySuggestions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>

                <div class="city-suggestions-box"
                  *ngIf="showCitySuggestions"
                  (mouseenter)="isHovering = true"
                  (mouseleave)="isHovering = false; maybeHideSuggestions()">

                  <div class="section">
                    <h6>Popular Cities</h6>
                    <div class="city-grid">
                      <span *ngFor="let city of popularCities"
                        (click)="selectCity(city)">
                        {{ city.name }}
                      </span>
                    </div>
                  </div>

                  <div class="section">
                    <h6>Other Cities</h6>
                    <div class="city-grid">
                      <span *ngFor="let city of otherCities"
                        (click)="selectCity(city)">
                        {{ city.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->

            </span>
          </li>

          <li class="nav-item">
            <span class="nav-link text-white mts-2 setbutton"
              style="cursor: pointer;"
              (click)="rentAgreementNavigate()">Rent
              Agreement</span>
          </li>
          <!-- <li class="nav-item">
            <span class="nav-link text-white mts-2"  (click)="loginnavigate()">Rent
              Calculator</span>
          </li> -->

        </ul>
      </div>

      <div class="d-flex align-items-center endside">
        <span class="btn  btn-lights setbutton" (click)="propertynavigate()">
          <i class="fa fa-files-o"></i>&nbsp;&nbsp;&nbsp; List Property
          <span class="badge btn-warning text-dark badge-custom">Free</span>
        </span>

        <span class="btn btn-outline-light me-2 custom-btn setbutton"
          (click)="loginnavigate()">
          <i class="fa-regular fa-user"></i>
          &nbsp;&nbsp; Sign in / Register
        </span>
        <!-- <span class="btn btn-lights me-2" (click)="loginnavigate()">
          <i class="fa fa-building"></i>&nbsp;&nbsp;&nbsp; Real Estate Projects
          <span class="badge bg-dark text-white badge-custom">Free</span>
        </span> -->

      </div>
    </div>
  </ng-template>
</nav>

<!-- Mobile Navbar -->
<nav
  class="mobile-navbar d-lg-none d-flex justify-content-between align-items-center px-3 py-2 bg-primarys fixed-top">
  <!-- Hamburger menu -->
  <button class="btn text-white p-0" (click)="toggleMobileMenu()">
    <i class="fa fa-bars fa-lg"></i>
  </button>

  <!-- Center logo -->
  <a class="navbar-brand mx-auto" href="/">
    <img src="assets/images/Group 38.png" alt="Logo" class="mobile-logo">
  </a>

  <!-- Profile Icon -->
  <!-- <button class="btn text-white p-0" *ngIf="useremail; else showLogin"
    [matMenuTriggerFor]="mobileMenu">
    <i class="fa  fa-user-circle fa-lg"></i>
  </button> -->
  <ng-container *ngIf="adminlogo; else noImage">
    <div
      class="dropdown-wrapper"
      [matMenuTriggerFor]="mobileMenu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="onMenuClosed()">
      <img [src]="adminlogo" class="admin-profile-img" alt="Profile" />
      <mat-icon class="dropdown-do">
        {{ menuOpen ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
  </ng-container>

  <ng-template #noImage>
    <button mat-icon-button [matMenuTriggerFor]="mobileMenu"
      class="user-icon setbutton">
      <i class="fa fa-user-circle fa-lg"></i>
    </button>
  </ng-template>
  <ng-template #showLogin>
    <button class="btn text-white p-0" (click)="loginnavigate()">
      <i class="fa  fa-user-circle fa-lg"></i>
    </button>
  </ng-template>

  <!-- Mobile Menu Dropdown -->
  <mat-menu #mobileMenu="matMenu">
    <button mat-menu-item
      routerLink="/update/profile/username/userid/activetab">
      <i class="fas fa-user text-primary"></i>&nbsp; Manage Profile
    </button>
    <button mat-menu-item (click)="navigateToUserProprty()">
      <i class="fa fa-building text-primary"></i>&nbsp; My Listings
    </button>
    <button mat-menu-item *ngIf="builder" (click)="navigateToUserProjects()">
      <i class="fa fa-home text-primary"></i>&nbsp; My Projects
    </button>
    <button mat-menu-item (click)="userLogout()">
      <i class="fas fa-sign-out-alt text-primary"></i>&nbsp; Logout
    </button>
  </mat-menu>
</nav>

<!-- Mobile Side Menu Content -->
<div class="mobile-side-menu" *ngIf="isMobileMenuOpen">
  <div class="menu-content bg-white shadow p-3">
    <ng-container *ngIf="!useremail">
      <!-- <div class="menu-item" (click)="loginnavigate()">Real Estate
        Projects</div> -->
      <div class="menu-item" (click)="propertynavigate()">List Property</div>
    </ng-container>
    <ng-container *ngIf="useremail">
      <!-- <div class="menu-item" (click)="projectnavigate()">Real Estate
        Projects</div> -->
      <div class="menu-item" (click)="propertynavigate()">List Property</div>
    </ng-container>
  </div>
</div>
